var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dat-wrapper"},[_c('depositRenderData',{attrs:{"data":_vm.checkingAccountData,"viewButtonText":_vm.viewButtonText,"bankHealth":_vm.bankHealth,"hasError":_vm.hasError,"bonusAmount":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }